import ApiService from "@/core/services/api.service";
import SiteService from "@/core/services/site.service.js";

const state = {
    errors: null,
    collection: []
};

const getters = {
    newsBlockTypeCollection(state) {
        return state.collection;
    }

    /*getNewsAuthorByID: (state) => (id) => {
        let item = state.collection.find((item) => item.id == id);
        if (!item) {
          item = null;
        }
        return item;
    }*/
};

const actions = {
    fetchNewsBlockType(context) {
        return new Promise((resolve) => {
            //let appLocale = i18nService.getActiveLanguage();
            ApiService.get(
                "news/admin/" + SiteService.getActiveSiteId() + "/news-main-page-editor/get-block-types"
            ).then(({ data }) => {
              context.commit("fetchNewsBlockType", data);
              resolve();
          });
        }).catch((error) => {
            console.log("Error!: ", error);
        });
    }
};

const mutations = {
    fetchNewsBlockType(state, data) {
      state.collection = data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};